<template>
  <div class="page-container">
    <md-app
      md-waterfall
      md-mode="fixed">
      <md-app-toolbar>
        <div class="md-toolbar-row">
          <ScenarioHeader
            :scenario-id="parseInt($route.params.scenarioId)"
            :scenario-state="scenarioDetails.scenario_state"
          />
        </div>
      </md-app-toolbar>
      <md-app-content class="page-content">
        <div class="page-layout">
          <template>
            <div class="results__panel">
              <div class="filters-wrapper">
                <md-field>
                  <label for="id_select_park_type">Parc:</label>
                  <md-select
                    v-model="displayFilters.selectedParkType"
                    name="Parc"
                    id="id_select_park_type">
                    <md-option value="Parc total">Parc total</md-option>
                    <md-option value="Parc permanent">Parc permanent</md-option>
                  </md-select>
                </md-field>

                <md-field>
                  <label for="id_tertiary_decree">Patrimoine:</label>
                  <md-select
                    v-model="displayFilters.tertiaryDecree"
                    name="Patrimoine"
                    id="id_tertiary_decree">
                    <md-option :value="true">Assujettis décret tertiaire</md-option>
                    <md-option :value="false">Patrimoine complet</md-option>
                  </md-select>
                </md-field>

                <md-field>
                  <label for="id_places_type">Filtrer par</label>
                  <md-select
                    v-model="placesType"
                    name="Filtrer par"
                    id="id_places_type"
                  >
                    <md-option
                      v-for="typeValue in Object.keys(placesTypeValues)"
                      :key="`places-type-value-${typeValue}`"
                      :value="typeValue">{{ placesTypeValues[typeValue] }}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="tabs-wrapper">
                <md-tabs
                  @md-changed="graphTabChanged"
                  class="graphs-tabs">
                  <md-tab
                    id="tab-consumption"
                    md-label="Consommation finale" />
                  <md-tab
                    id="tab-emissions"
                    md-label="Émissions de GES" />
                  <md-tab
                    id="tab-costs"
                    md-label="Investissements et économie cumulés" />
                  <md-tab
                    id="tab-energy-mix"
                    md-label="Mix énergétique" />
                </md-tabs>

                <md-content v-if="graphTab === 'tab-consumption'">
                  <BarChart
                    :options="consumptionChart.chartOptions"
                    :chart-data="consumptionChart.dataCollection"
                    :gen-legend="false"
                    :width="800"
                    :height="600"
                  />
                </md-content>

                <md-content v-if="graphTab === 'tab-emissions'">
                  <BarChart
                    :options="emissionsChart.chartOptions"
                    :chart-data="emissionsChart.dataCollection"
                    :gen-legend="false"
                    :width="800"
                    :height="600"
                  />
                </md-content>

                <md-content v-if="graphTab === 'tab-costs'">
                  <BarChart
                    :options="costsChart.options"
                    :chart-data="costsChart.dataCollection"
                    :gen-legend="false"
                    :width="800"
                    :height="600"
                  />
                </md-content>

                <md-content v-if="graphTab === 'tab-energy-mix'">
                  <div class="energy-mix-filters">
                    <md-field>
                      <label for="data_type">Donnée</label>
                      <md-select
                        v-model="energyMixChart.dataType"
                        name="data_type"
                        id="id_energy_mix_chart_data_type"
                        placeholder="Donnée"
                      >
                        <md-option
                          v-for="dataType in energyMixChart.dataTypes"
                          :key="`energy-mix-chart-type-${dataType.key}`"
                          :value="dataType.key"
                        >{{ dataType.label }}
                        </md-option>
                      </md-select>
                    </md-field>

                    <md-field>
                      <label for="data_representation">Représentation</label>
                      <md-select
                        v-model="energyMixChart.dataRepresentation"
                        name="data_representation"
                        id="id_energy_mix_chart_data_representation"
                        placeholder="Représentation"
                      >
                        <md-option
                          v-for="dataRepresentation in energyMixChart.dataRepresentations"
                          :key="`energy-mix-chart-representation-${dataRepresentation.key}`"
                          :value="dataRepresentation.key"
                        >{{ dataRepresentation.label }}</md-option
                        >
                      </md-select>
                    </md-field>
                    <md-field>
                      <label for="year">Année</label>
                      <md-select
                        v-model="energyMixChart.year"
                        name="year"
                        id="id_energy_mix_chart_year"
                        placeholder="Année"
                      >
                        <md-option
                          v-for="year in energyMixChart.years"
                          :key="`energy-mix-chart-year-${year}`"
                          :value="year"
                        >{{ year }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </div>

                  <PieChart
                    :options="energyMixChart.options"
                    :chart-data="energyMixChart.dataCollection"
                    :width="400"
                    :height="400"
                  />
                </md-content>
              </div>
            </div>
            <div class="filters__panel">
              <template>
                <div>
                  <md-content class="filters-panel-line">
                    <md-table
                      class="consumption-table"
                      md-card>
                      <md-table-toolbar>
                        <div class="filters-title">Sélection</div>
                      </md-table-toolbar>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                          rowspan="4"
                        >Sélection</md-table-head
                        >
                        <md-table-cell
                          colspan="3"
                        >{{ metaDatas.selectedPlaces }} /
                        <em>{{ metaDatas.totalPlaces }} zones</em></md-table-cell
                        >
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell
                          colspan="3"
                        >{{ metaDatas.selectedBuildings }} /
                        <em>{{ metaDatas.totalBuildings }} bâtiments</em></md-table-cell
                        >
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell
                          colspan="3"
                        >{{ metaDatas.selectedSites }} /
                        <em>{{ metaDatas.totalSites }} sites</em></md-table-cell
                        >
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell
                          colspan="3"
                        >{{ metaDatas.selectedSU | formatIntNumber }} /
                          <em
                          >{{ metaDatas.totalSU | formatIntNumber }} m² SU</em
                        ></md-table-cell
                        >
                      </md-table-row>
                      <md-table-row v-if="metaDatas.lastRealConsumptionYear">
                        <md-table-head
                          class="consumption-col-header"
                        >Consommation
                          {{ metaDatas.lastRealConsumptionYear }} (GWhEF)</md-table-head
                          >
                        <md-table-cell colspan="3">{{
                          metaDatas.lastRealConsumption
                        }}</md-table-cell>
                      </md-table-row>
                      <md-table-row v-if="metaDatas.lastRealConsumptionYear">
                        <md-table-head
                          class="consumption-col-header"
                        >Consommation
                          {{ metaDatas.lastRealConsumptionYear }}
                          (kWhEF/m²SU)</md-table-head
                          >
                        <md-table-cell colspan="3">{{
                          metaDatas.lastRealConsumptionSU
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-head class="consumption-col-header" />
                        <md-table-head class="date-header">2030</md-table-head>
                        <md-table-head class="date-header">2040</md-table-head>
                        <md-table-head class="date-header">2050</md-table-head>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Consommation (GWhEF)</md-table-head
                        >
                        <md-table-cell>{{ metaDatas.consumption2030 }}</md-table-cell>
                        <md-table-cell>{{ metaDatas.consumption2040 }}</md-table-cell>
                        <md-table-cell>{{ metaDatas.consumption2050 }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Consommation (kWhEF/m²SU)</md-table-head
                        >
                        <md-table-cell>{{ metaDatas.consumption2030SU }}</md-table-cell>
                        <md-table-cell>{{ metaDatas.consumption2040SU }}</md-table-cell>
                        <md-table-cell>{{ metaDatas.consumption2050SU }}</md-table-cell>
                      </md-table-row>

                      <template v-if="displayFilters.tertiaryDecree">
                        <md-table-row>
                          <md-table-head
                            class="consumption-col-header"
                          >Objectif décret tertiaire (GWh)</md-table-head
                          >
                          <md-table-cell>{{
                            metaDatas.tertiaryDecree2030
                          }}</md-table-cell>
                          <md-table-cell>{{
                            metaDatas.tertiaryDecree2040
                          }}</md-table-cell>
                          <md-table-cell>{{
                            metaDatas.tertiaryDecree2050
                          }}</md-table-cell>
                        </md-table-row>

                        <md-table-row>
                          <md-table-head
                            class="consumption-col-header"
                          >Objectif décret tertiaire (kWhEF/m²SU)
                          </md-table-head>
                          <md-table-cell>{{
                            metaDatas.tertiaryDecree2030SU
                          }}</md-table-cell>
                          <md-table-cell>{{
                            metaDatas.tertiaryDecree2040SU
                          }}</md-table-cell>
                          <md-table-cell>{{
                            metaDatas.tertiaryDecree2050SU
                          }}</md-table-cell>
                        </md-table-row>
                      </template>

                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Objectif Planiss'Immo (kWhEF/m²SU)</md-table-head
                        >
                        <md-table-cell>{{
                          metaDatas.negawattTrajectory2030SU
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.negawattTrajectory2040SU
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.negawattTrajectory2050SU
                        }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Émissions GES vecteurs constants (tCO2eq)
                        </md-table-head>
                        <md-table-cell>{{
                          metaDatas.constantCo2Emissions2030
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.constantCo2Emissions2040
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.constantCo2Emissions2050
                        }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Émissions GES vecteurs décarbonés (tCO2eq)
                        </md-table-head>
                        <md-table-cell>{{
                          metaDatas.prospectiveCo2Emissions2030
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.prospectiveCo2Emissions2040
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.prospectiveCo2Emissions2050
                        }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Investissements total annuel moyen (M€TTC)
                        </md-table-head>
                        <md-table-cell>{{
                          metaDatas.cumulativeTotalInvestment2030
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.cumulativeTotalInvestment2040
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.cumulativeTotalInvestment2050
                        }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >dont investissement énergie (M€TTC)
                        </md-table-head>
                        <md-table-cell>{{
                          metaDatas.energyInvestment2030
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.energyInvestment2040
                        }}</md-table-cell>
                        <md-table-cell>{{
                          metaDatas.energyInvestment2050
                        }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Économie annuelle moyenne (M€TTC)</md-table-head
                        >
                        <md-table-cell>{{ metaDatas.economy2030 }}</md-table-cell>
                        <md-table-cell>{{ metaDatas.economy2040 }}</md-table-cell>
                        <md-table-cell>{{ metaDatas.economy2050 }}</md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-head
                          class="consumption-col-header"
                        >Temps de retour</md-table-head
                        >
                        <md-table-cell colspan="3">{{
                          scenarioDetails.return_time
                        }}</md-table-cell>
                      </md-table-row>
                    </md-table>

                    <md-table
                      v-model="functionsList"
                      :md-selected-value="selectedFunctions"
                      @md-selected="onFunctionsSelect"
                      class="function-list-table filters-table"
                    >
                      <md-table-toolbar>
                        <div class="filters-title">Fonctions</div>
                      </md-table-toolbar>

                      <md-table-row
                        slot="md-table-row"
                        slot-scope="{ item }"
                        md-selectable="multiple"
                        md-auto-select
                      >
                        <md-table-cell md-label="Fonction">{{
                          item.label
                        }}</md-table-cell>
                        <md-table-cell :md-label="placesTypeDisplay">{{
                          item.places_count
                        }}</md-table-cell>
                      </md-table-row>
                    </md-table>

                    <md-table
                      v-model="tagsList"
                      :md-selected-value="selectedTags"
                      @md-selected="onTagsSelect"
                      class="filters-table"
                    >
                      <md-table-toolbar>
                        <div class="filters-title">Tags</div>
                      </md-table-toolbar>

                      <md-table-row
                        slot="md-table-row"
                        slot-scope="{ item }"
                        md-selectable="multiple"
                        md-auto-select
                      >
                        <md-table-cell md-label="Tag">{{ item.name }}</md-table-cell>
                        <md-table-cell :md-label="placesTypeDisplay">{{
                          item.places_count
                        }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                  </md-content>
                  <div class="md-fab md-mini">
                    <md-tooltip
                      v-if="xlsxGenerating"
                      md-direction="left">{{ xlsxGeneratingMsg }}</md-tooltip>
                    <md-button
                      class="md-primary"
                      @click="downloadXLSXResult()"
                      :disabled="xlsxGenerating"
                    >
                      <md-icon>cloud_download</md-icon>
                    </md-button>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import FileDownload from 'js-file-download'
import session from '../api/session'
import ScenarioHeader from '../components/ScenarioHeader.vue'
import BarChart from '../components/BarChart.vue'
import PieChart from '../components/PieChart.vue'
import ChartValuesMixin from '../mixins/ChartValuesMixin'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'

const _ = require('lodash')

export default {
  name: 'ScenarioResults',
  mixins: [ChartValuesMixin, ValuesDisplayMixin],
  components: {
    ScenarioHeader,
    BarChart,
    PieChart
  },
  data () {
    return {
      functionsList: [],
      tagsList: [],
      energiesList: [],
      energiesLabel: {},
      energiesColors: {
        bois: '#5eb762', // Vert
        electricite: '#38a1f4', // Blue
        fioul: '#764ebe', // Violet
        gaz: '#ffc720', // Jaune
        'reseau-de-chaleur': '#795548', // Marron
        propane: '#9e9e9e', // Gris
        'pompe-a-chaleur-performante': '#3d556e' // Bleu foncé
      },
      placesTypeValues: {
        area: 'Zones',
        building: 'Bâtiments',
        site: 'Sites'
      },
      scenarioDetails: { scenario_state: 'new' },
      scenarioStatesTimer: null,
      graphTab: 'tab-consumption',
      chartData: [],
      metaDatas: {
        totalPlaces: 0,
        selectedPlaces: 0,
        totalBuildings: 0,
        selectedBuildings: 0,
        totalSites: 0,
        selectedSites: 0,
        selectedSU: 0,
        totalSU: 0,
        lastRealConsumption: 0,
        lastRealConsumptionSU: 0,
        lastRealConsumptionYear: 0,
        consumption2030: 0,
        consumption2040: 0,
        consumption2050: 0,
        consumption2030SU: 0,
        consumption2040SU: 0,
        consumption2050SU: 0,
        tertiaryDecree2030: 0,
        tertiaryDecree2040: 0,
        tertiaryDecree2050: 0,
        tertiaryDecree2030SU: 0,
        tertiaryDecree2040SU: 0,
        tertiaryDecree2050SU: 0,
        negawattTrajectory2030SU: 0,
        negawattTrajectory2040SU: 0,
        negawattTrajectory2050SU: 0,
        cumulativeTotalInvestment2030: 0,
        cumulativeTotalInvestment2040: 0,
        cumulativeTotalInvestment2050: 0,
        constantCo2Emissions2030: 0,
        constantCo2Emissions2040: 0,
        constantCo2Emissions2050: 0,
        prospectiveCo2Emissions2030: 0,
        prospectiveCo2Emissions2040: 0,
        prospectiveCo2Emissions2050: 0,
        energyInvestment2030: 0,
        energyInvestment2040: 0,
        energyInvestment2050: 0,
        economy2030: 0,
        economy2040: 0,
        economy2050: 0
      },

      selectedFunctions: [],
      selectedTags: [],
      placesType: 'area',
      displayFilters: {
        selectedFunctions: [],
        selectedTags: [],
        selectedParkType: 'Parc total',
        tertiaryDecree: true
      },

      consumptionChart: {
        dataCollection: {},
        chartOptions: {},
        dataLabels: [],
        realConsumptionData: [],
        planissimmoData: [],
        nWData: [],
        maxInvestmentData: [],
        energyInvestmentData: [],
        totalInvestmentData: [],
        economyData: [],
        LTECVData: [],
        TD2030Data: [],
        TD2040Data: [],
        TD2050Data: []
      },

      emissionsChart: {
        dataCollection: {},
        chartOptions: {},
        dataLabels: [],
        realCO2emissionsData: [],
        constantCO2emissionsData: [],
        prospectiveCO2emissionsData: []
      },

      costsChart: {
        dataCollection: {},
        options: {},
        dataLabels: [],
        cumulativeEnergyInvestmentData: [],
        cumulativeMaxInvestmentData: [],
        cumulativeTotalInvestmentData: [],
        cumulativeEconomyData: []
      },

      energyMixChart: {
        dataCollection: {},
        options: {},
        year: null,
        years: [],
        dataRepresentation: 'value',
        dataRepresentations: [
          {
            key: 'value',
            label: 'Valeur'
          },
          {
            key: 'percentage',
            label: 'Pourcentage'
          }
        ],
        dataType: 'cost',
        dataTypes: [
          {
            key: 'cost',
            label: 'Coût'
          },
          {
            key: 'consumption',
            label: 'Consommation'
          },
          {
            key: 'co2_emissions',
            label: 'Émissions GES'
          }
        ],
        dataTotal: 0
      }
    }
  },
  created () {
    // _.debounce est une fonction fournie par lodash pour limiter la fréquence
    // d'exécution d'une opération particulièrement coûteuse.
    // Pour en savoir plus sur la fonction `_.debounce` (et sa cousine
    // `_.throttle`), visitez : https://lodash.com/docs#debounce
    this.debouncedGetChartData = _.debounce(this.getChartData, 1000)
  },
  async mounted () {
    this.$store.dispatch('routing/update_title', 'Résultats')
    this.$store.dispatch('routing/update_return_kwargs', null)
    await this.loadApi()
    this.$store.dispatch('routing/update_title', this.scenarioDetails.label)

    if (this.scenarioDetails.generating) {
      this.$router.push({name: 'Scenarios list'})
    }

    if (this.xlsxGenerating) {
      this.scenarioStatesTimer = setInterval(this.getScenarioDetails, 3000)
    }
  },
  destroyed () {
    // The timer must be stopped when the component is destroyed otherwise it will continue to run
    if (this.scenarioStatesTimer) {
      clearInterval(this.scenarioStatesTimer)
    }
  },
  computed: {
    placesTypeDisplay () {
      return this.placesTypeValues[this.placesType]
    },
    xlsxGenerating () {
      return this.scenarioDetails.scenario_state === 'generating_frontend_xlsx'
    },
    xlsxGenerationPercentage () {
      if (this.scenarioDetails.xlsx_generation_percentage) {
        return ValuesDisplayMixin.filters.displayPercentageAsInt(this.scenarioDetails.xlsx_generation_percentage)
      } else {
        return null
      }
    },
    xlsxGeneratingMsg () {
      const xlsxGenerationPercentage = this.xlsxGenerationPercentage
      if (xlsxGenerationPercentage) {
        return `Génération du fichier XLSX en cours (${xlsxGenerationPercentage}), le fichier sera bientôt disponible`
      } else {
        return 'Génération du fichier XLSX en cours'
      }
    }
  },
  watch: {
    placesType: {
      handler (value) {
        this.loadFunctions()
        this.loadTags()
      }
    },
    selectedFunctions: {
      immediate: true,
      handler (value) {
        this.displayFilters.selectedFunctions = []
        if (this.functionsList.length !== this.selectedFunctions.length) {
          this.displayFilters.selectedFunctions = this.selectedFunctions.map(
            (func) => func.id
          )
        }
      }
    },
    selectedTags: {
      immediate: true,
      handler (value) {
        this.displayFilters.selectedTags = []
        if (this.tagsList.length !== this.selectedTags.length) {
          this.displayFilters.selectedTags = this.selectedTags.map((tag) => tag.id)
        }
      }
    },
    displayFilters: {
      handler (val) {
        this.debouncedGetChartData()
      },
      deep: true
    },
    'energyMixChart.year': {
      handler (val) {
        this.computeEnergyMixChartValues()
      },
      deep: true
    },
    'energyMixChart.dataRepresentation': {
      handler (val) {
        this.computeEnergyMixChartValues()
      },
      deep: true
    },
    'energyMixChart.dataType': {
      handler (val) {
        this.computeEnergyMixChartValues()
      },
      deep: true
    }
  },
  methods: {
    graphTabChanged (activeTab) {
      this.graphTab = activeTab
    },
    onFunctionsSelect (items) {
      this.selectedFunctions = items
    },
    onTagsSelect (items) {
      this.selectedTags = items
    },
    toGig (value) {
      return Math.round((value / 1000000 + Number.EPSILON) * 100) / 100
    },
    toKilo (value) {
      return Math.round((value / 1000 + Number.EPSILON) * 10000) / 10000
    },
    async getScenarioDetails () {
      const scenarioId = this.$route.params.scenarioId

      const scenarioDetailsResponse = await session.get(`/api/scenario/${scenarioId}/`)

      this.scenarioDetails = scenarioDetailsResponse.data

      if (!this.xlsxGenerating && this.scenarioStatesTimer) {
        clearInterval(this.scenarioStatesTimer)

        this.$store.commit('messages/SHOW', {
          label: 'Export XLSX',
          description: 'Le fichier d\'export XLSX du scénario a été généré'
        })
      }
    },
    async getChartData () {
      const scenarioId = this.$route.params.scenarioId

      this.$store.dispatch('loading/begin_loading')

      const queryParams = { tags: this.displayFilters.selectedTags, places_type: this.placesType }

      if (this.displayFilters.selectedFunctions.length !== this.functionsList.length) {
        queryParams.functions = this.displayFilters.selectedFunctions
      }

      if (this.displayFilters.selectedParkType === 'Parc total') {
        queryParams.park_type = 'total'
      } else {
        queryParams.park_type = 'permanent'
      }

      if (this.displayFilters.tertiaryDecree) {
        queryParams.tertiary_decree = true
      }

      const chartResponse = await session.get(`/api/scenario/results/${scenarioId}/`, {
        params: queryParams
      })

      this.chartData = chartResponse.data

      // Re-init data tables

      // Consumption chart
      this.consumptionChart.dataLabels = []
      this.consumptionChart.realConsumptionData = []
      this.consumptionChart.planissimmoData = []
      this.consumptionChart.nWData = []
      this.consumptionChart.maxInvestmentData = []
      this.consumptionChart.energyInvestmentData = []
      this.consumptionChart.totalInvestmentData = []
      this.consumptionChart.economyData = []
      this.consumptionChart.LTECVData = []
      this.consumptionChart.TD2030Data = []
      this.consumptionChart.TD2040Data = []
      this.consumptionChart.TD2050Data = []

      // Emissions chart
      this.emissionsChart.dataLabels = []
      this.emissionsChart.realCO2emissionsData = []
      this.emissionsChart.constantCO2emissionsData = []
      this.emissionsChart.prospectiveCO2emissionsData = []

      // Costs chart
      this.costsChart.dataLabels = []
      this.costsChart.cumulativeEnergyInvestmentData = []
      this.costsChart.cumulativeMaxInvestmentData = []
      this.costsChart.cumulativeTotalInvestmentData = []
      this.costsChart.cumulativeEconomyData = []

      // Re-init metadatas
      Object.keys(this.metaDatas).forEach((key) => {
        this.metaDatas[key] = 0
      })

      // Build data labels
      Array.from(
        new Array(this.chartData.max_year - this.chartData.min_year + 1),
        (val, index) => this.chartData.min_year + index
      ).forEach(function (year) {
        this.consumptionChart.dataLabels.push(year)
        this.emissionsChart.dataLabels.push(year)
        if (year >= this.chartData.scenario_year) {
          this.costsChart.dataLabels.push(year)
        }
      }, this)

      this.consumptionChart.dataLabels.forEach((year) => {
        let yearPlanissimmoConsolidatedData = null

        if (
          year in this.chartData.planissimmo_consolidated_data &&
          this.chartData.planissimmo_consolidated_data[year] != null
        ) {
          yearPlanissimmoConsolidatedData =
            this.chartData.planissimmo_consolidated_data[year] / 1000
        }

        this.consumptionChart.planissimmoData.push({
          x: year,
          y: yearPlanissimmoConsolidatedData
        })

        if (year in this.chartData.negawatt_trajectory_data) {
          this.consumptionChart.nWData.push({
            x: year,
            y: this.chartData.negawatt_trajectory_data[year] / 1000
          })
        } else {
          this.consumptionChart.nWData.push({ x: year, y: null })
        }

        if (year in this.chartData.allocated_investment) {
          this.consumptionChart.maxInvestmentData.push({
            x: year,
            y: this.chartData.allocated_investment[year] / 1000000
          })
        } else {
          this.consumptionChart.maxInvestmentData.push({ x: year, y: null })
        }

        if (year in this.chartData.cumulative_year_energy_investment) {
          this.consumptionChart.energyInvestmentData.push({
            x: year,
            y: this.chartData.cumulative_year_energy_investment[year] / 1000000
          })
        } else {
          this.consumptionChart.energyInvestmentData.push({ x: year, y: null })
        }

        if (year in this.chartData.cumulative_year_total_investment) {
          this.consumptionChart.totalInvestmentData.push({
            x: year,
            y: this.chartData.cumulative_year_total_investment[year] / 1000000
          })
        } else {
          this.consumptionChart.totalInvestmentData.push({ x: year, y: null })
        }

        if (year in this.chartData.economy_year_data) {
          this.consumptionChart.economyData.push({
            x: year,
            y: this.chartData.economy_year_data[year] / 1000000
          })
        } else {
          this.consumptionChart.economyData.push({ x: year, y: null })
        }

        if (year in this.chartData.real_consumption_data) {
          this.consumptionChart.realConsumptionData.push({
            x: year,
            y: this.chartData.real_consumption_data[year] / 1000
          })
        } else {
          this.consumptionChart.realConsumptionData.push({ x: year, y: null })
        }

        if (year in this.chartData.ltecv_data) {
          this.consumptionChart.LTECVData.push({
            x: year,
            y: this.chartData.ltecv_data[year] / 1000
          })
        } else {
          this.consumptionChart.LTECVData.push({ x: year, y: null })
        }

        if (year in this.chartData.tertiary_decree_2030_data) {
          this.consumptionChart.TD2030Data.push({
            x: year,
            y: this.chartData.tertiary_decree_2030_data[year] / 1000
          })
        } else {
          this.consumptionChart.TD2030Data.push({ x: year, y: null })
        }

        if (year in this.chartData.tertiary_decree_2040_data) {
          this.consumptionChart.TD2040Data.push({
            x: year,
            y: this.chartData.tertiary_decree_2040_data[year] / 1000
          })
        } else {
          this.consumptionChart.TD2040Data.push({ x: year, y: null })
        }

        if (year in this.chartData.tertiary_decree_2050_data) {
          this.consumptionChart.TD2050Data.push({
            x: year,
            y: this.chartData.tertiary_decree_2050_data[year] / 1000
          })
        } else {
          this.consumptionChart.TD2050Data.push({ x: year, y: null })
        }
      })

      this.emissionsChart.dataLabels.forEach((year) => {
        if (year in this.chartData.real_CO2emissions_data) {
          this.emissionsChart.realCO2emissionsData.push({
            x: year,
            y: this.chartData.real_CO2emissions_data[year]
          })
        } else {
          this.emissionsChart.realCO2emissionsData.push({ x: year, y: null })
        }

        if (year in this.chartData.constant_CO2emissions_data) {
          this.emissionsChart.constantCO2emissionsData.push({
            x: year,
            y: this.chartData.constant_CO2emissions_data[year]
          })
        } else {
          this.emissionsChart.constantCO2emissionsData.push({ x: year, y: null })
        }

        if (year in this.chartData.prospective_CO2emissions_data) {
          this.emissionsChart.prospectiveCO2emissionsData.push({
            x: year,
            y: this.chartData.prospective_CO2emissions_data[year]
          })
        } else {
          this.emissionsChart.prospectiveCO2emissionsData.push({ x: year, y: null })
        }
      })

      // Consumption chart
      const consumptionsDatas = [
        this.consumptionChart.realConsumptionData,
        this.consumptionChart.LTECVData,
        this.consumptionChart.TD2030Data,
        this.consumptionChart.TD2040Data,
        this.consumptionChart.TD2050Data,
        this.consumptionChart.planissimmoData,
        this.consumptionChart.nWData
      ]

      const costsDatas = [
        this.consumptionChart.economyData,
        this.consumptionChart.maxInvestmentData,
        this.consumptionChart.energyInvestmentData,
        this.consumptionChart.totalInvestmentData
      ]

      const [
        nbConsumptionsNegativeSteps,
        maxYConsumptions,
        yConsumptionsStep
      ] = this.computeYAxisBounds(consumptionsDatas)

      const [nbCostsNegativeSteps, maxYCosts, yCostsStep] = this.computeYAxisBounds(
        costsDatas
      )

      const nbconsumptionChartNegativeSteps = Math.max(
        nbConsumptionsNegativeSteps,
        nbCostsNegativeSteps
      )
      const minYConsumptions = -nbconsumptionChartNegativeSteps * yConsumptionsStep
      const minYCosts = -nbconsumptionChartNegativeSteps * yCostsStep

      this.consumptionChart.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Évolution de la consommation finale (corrigée du climat)'
        },
        legend: {
          position: 'bottom',
          labels: { usePointStyle: true, padding: 20, fontStyle: 'bold' }
        },
        scales: {
          xAxes: [
            {
              display: true,
              stacked: true,
              scaleLabel: {
                display: false,
                labelString: 'Années',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              gridLines: {
                offsetGridLines: false
              }
            }
          ],
          yAxes: [
            {
              id: 'y-axis-consumptions',
              scaleLabel: {
                display: true,
                labelString: 'MWh',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              type: 'linear',
              ticks: {
                beginAtZero: true,
                min: minYConsumptions,
                max: maxYConsumptions,
                stepSize: yConsumptionsStep
              },
              position: 'left'
            },
            {
              id: 'y-axis-costs',
              scaleLabel: {
                display: true,
                labelString: 'M€',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              type: 'linear',
              position: 'right',
              ticks: {
                beginAtZero: true,
                min: minYCosts,
                max: maxYCosts,
                stepSize: yCostsStep
              }
            }
          ]
        },
        tooltips: {
          mode: 'nearest',
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              label += Math.round(tooltipItem.yLabel * 100) / 100
              return label
            }
          }
        }
      }

      let tertiaryDecreeDatasets = []
      if (this.displayFilters.tertiaryDecree) {
        tertiaryDecreeDatasets = [
          {
            label: 'Objectif décret tertiaire 2030',
            backgroundColor: '#98cc06',
            borderColor: '#98cc06',
            borderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 4,
            fill: false,
            showLine: false,
            data: this.consumptionChart.TD2030Data,
            pointStyle: 'circle',
            type: 'line',
            yAxisID: 'y-axis-consumptions'
          },
          {
            label: 'Objectif décret tertiaire 2040',
            backgroundColor: '#FFFFFF',
            borderColor: '#98cc06',
            borderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 4,
            fill: false,
            showLine: false,
            data: this.consumptionChart.TD2040Data,
            pointStyle: 'circle',
            type: 'line',
            yAxisID: 'y-axis-consumptions'
          },
          {
            label: 'Objectif décret tertiaire 2050',
            backgroundColor: '#FFFFFF',
            borderColor: '#98cc06',
            borderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 4,
            fill: false,
            showLine: false,
            data: this.consumptionChart.TD2050Data,
            pointStyle: 'circle',
            type: 'line',
            yAxisID: 'y-axis-consumptions'
          }
        ]
      }

      this.consumptionChart.dataCollection = {
        labels: this.consumptionChart.dataLabels,
        datasets: [
          {
            label: 'Consommations réelles',
            backgroundColor: '#00ADEE',
            borderColor: '#00ADEE',
            pointRadius: 4,
            pointStyle: 'circle',
            fill: false,
            showLine: false,
            data: this.consumptionChart.realConsumptionData,
            type: 'line',
            yAxisID: 'y-axis-consumptions'
          },
          {
            label: 'Économie',
            backgroundColor: '#FE0800',
            borderColor: '#FE0800',
            borderWidth: 4,
            fill: false,
            showLine: false,
            data: this.consumptionChart.economyData,
            pointStyle: 'triangle',
            type: 'line',
            yAxisID: 'y-axis-costs'
          },
          // {
          //   label: 'Objectif tertiaire LTECV',
          //   backgroundColor: '#FF0A00',
          //   borderColor: '#FF0A00',
          //   borderWidth: 4,
          //   fill: false,
          //   showLine: false,
          //   data: this.consumptionChart.LTECVData,
          //   pointStyle: 'circle',
          //   type: 'line',
          //   yAxisID: 'y-axis-consumptions'
          // },
          ...tertiaryDecreeDatasets,
          {
            label: 'Consommations du scénario',
            backgroundColor: '#006EB9',
            borderColor: '#006EB9',
            borderWidth: 2,
            fill: false,
            data: this.consumptionChart.planissimmoData,
            radius: 1.5,
            type: 'line',
            pointStyle: 'line',
            yAxisID: 'y-axis-consumptions',
            lineTension: 0,
            cubicInterpolationMode: 'linear'
          },
          // {
          //   label: 'Trajectoire objectif',
          //   backgroundColor: '#92CF5D',
          //   borderColor: '#92CF5D',
          //   borderWidth: 2,
          //   fill: false,
          //   data: this.consumptionChart.nWData,
          //   radius: 1.5,
          //   type: 'line',
          //   pointStyle: 'line',
          //   yAxisID: 'y-axis-consumptions',
          //   lineTension: 0,
          //   cubicInterpolationMode: 'linear'
          // },
          {
            label: 'Investissement total possible',
            backgroundColor: '#FE983E',
            borderColor: '#B16935',
            borderWidth: 2,
            pointRadius: 6,
            fill: false,
            showLine: false,
            data: this.consumptionChart.maxInvestmentData,
            pointStyle: 'rect',
            type: 'line',
            yAxisID: 'y-axis-costs'
          },
          {
            label: 'Investissement énergie',
            backgroundColor: '#FEC02C',
            borderColor: '#FEC02C',
            data: this.consumptionChart.energyInvestmentData,
            type: 'bar',
            pointStyle: 'rect',
            yAxisID: 'y-axis-costs',
            barThickness: 8
          },
          {
            label: 'Investissement total',
            backgroundColor: '#FF973D',
            borderColor: '#FF973D',
            data: this.consumptionChart.totalInvestmentData,
            type: 'bar',
            pointStyle: 'rect',
            yAxisID: 'y-axis-costs',
            barThickness: 8
          }
        ]
      }

      // Emissions chart
      const CO2Datas = [
        this.emissionsChart.realCO2emissionsData,
        this.emissionsChart.constantCO2emissionsData,
        this.emissionsChart.prospectiveCO2emissionsData
      ]

      const [nbCO2NegativeSteps, maxYCO2, yCO2Step] = this.computeYAxisBounds(CO2Datas)
      const minYCO2 = -nbCO2NegativeSteps * yCO2Step

      this.emissionsChart.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: { display: true, text: 'Émissions de GES' },
        legend: {
          position: 'bottom',
          labels: { usePointStyle: true, padding: 20, fontStyle: 'bold' }
        },
        scales: {
          xAxes: [
            {
              display: true,
              stacked: true,
              scaleLabel: {
                display: false,
                labelString: 'Années',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              gridLines: {
                offsetGridLines: false
              }
            }
          ],
          yAxes: [
            {
              id: 'y-axis-co2',
              scaleLabel: {
                display: true,
                labelString: 'tCO2eq',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              type: 'linear',
              ticks: {
                beginAtZero: true,
                min: minYCO2,
                max: maxYCO2,
                stepSize: yCO2Step
              },
              position: 'left'
            }
          ]
        },
        tooltips: {
          mode: 'nearest',
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              label += Math.round(tooltipItem.yLabel * 100) / 100
              return label
            }
          }
        }
      }

      this.emissionsChart.dataCollection = {
        labels: this.emissionsChart.dataLabels,
        datasets: [
          {
            label: 'Contenu CO2 réel',
            backgroundColor: '#8800ee',
            borderColor: '#8800ee',
            pointRadius: 4,
            pointStyle: 'circle',
            fill: false,
            showLine: false,
            data: this.emissionsChart.realCO2emissionsData,
            type: 'line',
            yAxisID: 'y-axis-co2'
          },
          {
            label: 'Contenu CO2 vecteurs constants',
            backgroundColor: '#ee00ec',
            borderColor: '#ee00ec',
            borderWidth: 2,
            fill: false,
            data: this.emissionsChart.constantCO2emissionsData,
            radius: 1.5,
            type: 'line',
            pointStyle: 'line',
            yAxisID: 'y-axis-co2',
            lineTension: 0,
            cubicInterpolationMode: 'linear'
          },
          {
            label: 'Contenu CO2 décarbonation des vecteurs nationaux',
            backgroundColor: '#eed600',
            borderColor: '#eed600',
            borderWidth: 2,
            fill: false,
            data: this.emissionsChart.prospectiveCO2emissionsData,
            radius: 1.5,
            type: 'line',
            pointStyle: 'line',
            yAxisID: 'y-axis-co2',
            lineTension: 0,
            cubicInterpolationMode: 'linear'
          }
        ]
      }

      // Costs chart
      this.costsChart.dataLabels.forEach((year) => {
        if (year in this.chartData.cumulative_allocated_investment) {
          this.costsChart.cumulativeMaxInvestmentData.push({
            x: year,
            y: this.chartData.cumulative_allocated_investment[year] / 1000000
          })
        } else {
          this.costsChart.cumulativeMaxInvestmentData.push({ x: year, y: null })
        }

        if (year in this.chartData.cumulative_energy_investment) {
          this.costsChart.cumulativeEnergyInvestmentData.push({
            x: year,
            y: this.chartData.cumulative_energy_investment[year] / 1000000
          })
        } else {
          this.costsChart.cumulativeEnergyInvestmentData.push({ x: year, y: null })
        }

        if (year in this.chartData.cumulative_total_investment) {
          this.costsChart.cumulativeTotalInvestmentData.push({
            x: year,
            y: this.chartData.cumulative_total_investment[year] / 1000000
          })
        } else {
          this.costsChart.cumulativeTotalInvestmentData.push({ x: year, y: null })
        }

        if (year in this.chartData.cumulated_economy_year_data) {
          this.costsChart.cumulativeEconomyData.push({
            x: year,
            y: this.chartData.cumulated_economy_year_data[year] / 1000000
          })
        } else {
          this.costsChart.cumulativeEconomyData.push({ x: year, y: null })
        }
      })

      this.costsChart.options = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Évolution des investissements et économie cumulés'
        },
        legend: {
          position: 'bottom',
          labels: { usePointStyle: true, padding: 20, fontStyle: 'bold' }
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: 'Années',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              }
            }
          ],
          yAxes: [
            {
              id: 'y-axis-costs',
              scaleLabel: {
                display: true,
                labelString: 'M€',
                fontFamily: 'Montserrat',
                fontColor: 'black',
                fontStyle: 'bold'
              },
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        tooltips: {
          mode: 'nearest',
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              label += Math.round(tooltipItem.yLabel * 100) / 100
              return label
            }
          }
        }
      }

      this.costsChart.dataCollection = {
        labels: this.costsChart.dataLabels,
        datasets: [
          {
            label: 'Investissement énergie cumulé',
            backgroundColor: '#FFC107',
            borderColor: '#FFC107',
            borderWidth: 2,
            fill: false,
            data: this.costsChart.cumulativeEnergyInvestmentData,
            radius: 2,
            type: 'line',
            pointStyle: 'line',
            yAxisID: 'y-axis-costs',
            lineTension: 0,
            cubicInterpolationMode: 'linear'
          },
          {
            label: 'Investissement total cumulé possible',
            backgroundColor: '#FF5722',
            borderColor: '#FF5722',
            borderWidth: 2,
            fill: false,
            data: this.costsChart.cumulativeMaxInvestmentData,
            radius: 2,
            borderDash: [15, 5],
            type: 'line',
            pointStyle: 'dash',
            yAxisID: 'y-axis-costs'
          },
          {
            label: 'Investissement total cumulé',
            backgroundColor: '#9C27B0',
            borderColor: '#9C27B0',
            borderWidth: 2,
            fill: false,
            data: this.costsChart.cumulativeTotalInvestmentData,
            radius: 2,
            type: 'line',
            pointStyle: 'line',
            yAxisID: 'y-axis-costs',
            lineTension: 0,
            cubicInterpolationMode: 'linear'
          },
          {
            label: 'Économie cumulée',
            backgroundColor: '#8BC34A',
            borderColor: '#8BC34A',
            borderWidth: 2,
            fill: false,
            data: this.costsChart.cumulativeEconomyData,
            radius: 2,
            borderDash: [15, 5],
            type: 'line',
            pointStyle: 'dash',
            yAxisID: 'y-axis-costs'
          }
        ]
      }

      // Energy mix chart
      this.energyMixChart.years = Object.keys(this.chartData.energy_mix_data)

      if (
        !this.energyMixChart.years.includes(this.energyMixChart.year) &&
        this.energyMixChart.years.length > 0
      ) {
        const scenarioDetailsYear = this.scenarioDetails.year.toString()

        if (this.energyMixChart.years.includes(scenarioDetailsYear)) {
          this.energyMixChart.year = scenarioDetailsYear
        } else {
          this.energyMixChart.year = this.energyMixChart.years[0]
        }
      }

      // Fill search meta-datas
      this.metaDatas.totalPlaces = this.chartData.nb_total_places
      this.metaDatas.selectedPlaces = this.chartData.nb_places
      this.metaDatas.totalBuildings = this.chartData.nb_total_buildings
      this.metaDatas.selectedBuildings = this.chartData.nb_buildings
      this.metaDatas.totalSites = this.chartData.nb_total_sites
      this.metaDatas.selectedSites = this.chartData.nb_sites
      this.metaDatas.selectedSU = this.chartData.selected_su
      this.metaDatas.totalSU = this.chartData.total_su

      const realConsumptionYears = Object.keys(this.chartData.real_consumption_data)
      const lastRealConsumptionYear =
        realConsumptionYears[realConsumptionYears.length - 1]
      const lastRealConsumption = this.chartData.real_consumption_data[lastRealConsumptionYear]
      const lastRealSUConsumption = this.chartData.real_consumption_su_data[lastRealConsumptionYear]
      this.metaDatas.lastRealConsumptionYear = lastRealConsumptionYear
      this.metaDatas.lastRealConsumption = this.toGig(lastRealConsumption)

      this.metaDatas.lastRealConsumptionSU =
        Math.round((lastRealSUConsumption + Number.EPSILON) * 100) / 100
      this.metaDatas.consumption2030 = this.toGig(
        this.chartData.planissimmo_2030_total_data
      )
      this.metaDatas.consumption2040 = this.toGig(
        this.chartData.planissimmo_2040_total_data
      )
      this.metaDatas.consumption2050 = this.toGig(
        this.chartData.planissimmo_2050_total_data
      )

      this.metaDatas.consumption2030SU =
        Math.round(
          (this.chartData.planissimmo_2030_total_su_data + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.consumption2040SU =
        Math.round(
          (this.chartData.planissimmo_2040_total_su_data + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.consumption2050SU =
        Math.round(
          (this.chartData.planissimmo_2050_total_su_data + Number.EPSILON) * 100
        ) / 100

      if (this.displayFilters.tertiaryDecree) {
        this.metaDatas.tertiaryDecree2030 = this.toGig(
          this.chartData.tertiary_decree_2030_data['2030']
        )
        this.metaDatas.tertiaryDecree2040 = this.toGig(
          this.chartData.tertiary_decree_2040_data['2040']
        )
        this.metaDatas.tertiaryDecree2050 = this.toGig(
          this.chartData.tertiary_decree_2050_data['2050']
        )

        this.metaDatas.tertiaryDecree2030SU =
          Math.round(
            (this.chartData.tertiary_decree_2030_su_data['2030'] + Number.EPSILON) * 100
          ) / 100
        this.metaDatas.tertiaryDecree2040SU =
          Math.round(
            (this.chartData.tertiary_decree_2040_su_data['2040'] + Number.EPSILON) * 100
          ) / 100
        this.metaDatas.tertiaryDecree2050SU =
          Math.round(
            (this.chartData.tertiary_decree_2050_su_data['2050'] + Number.EPSILON) * 100
          ) / 100
      }

      this.metaDatas.negawattTrajectory2030SU =
        Math.round(
          (this.chartData.negawatt_trajectory_su_data['2030'] + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.negawattTrajectory2040SU =
        Math.round(
          (this.chartData.negawatt_trajectory_su_data['2040'] + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.negawattTrajectory2050SU =
        Math.round(
          (this.chartData.negawatt_trajectory_su_data['2050'] + Number.EPSILON) * 100
        ) / 100

      this.metaDatas.constantCo2Emissions2030 =
        Math.round(
          (this.chartData.constant_2030_CO2emissions_data + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.constantCo2Emissions2040 =
        Math.round(
          (this.chartData.constant_2040_CO2emissions_data + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.constantCo2Emissions2050 =
        Math.round(
          (this.chartData.constant_2050_CO2emissions_data + Number.EPSILON) * 100
        ) / 100

      this.metaDatas.prospectiveCo2Emissions2030 =
        Math.round(
          (this.chartData.prospective_2030_CO2emissions_data + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.prospectiveCo2Emissions2040 =
        Math.round(
          (this.chartData.prospective_2040_CO2emissions_data + Number.EPSILON) * 100
        ) / 100
      this.metaDatas.prospectiveCo2Emissions2050 =
        Math.round(
          (this.chartData.prospective_2050_CO2emissions_data + Number.EPSILON) * 100
        ) / 100

      this.metaDatas.cumulativeTotalInvestment2030 = this.toGig(
        this.chartData.cumulative_2030_total_investment
      )
      this.metaDatas.cumulativeTotalInvestment2040 = this.toGig(
        this.chartData.cumulative_2040_total_investment
      )
      this.metaDatas.cumulativeTotalInvestment2050 = this.toGig(
        this.chartData.cumulative_2050_total_investment
      )

      this.metaDatas.energyInvestment2030 = this.toGig(
        this.chartData.cumulative_2030_energy_investment
      )
      this.metaDatas.energyInvestment2040 = this.toGig(
        this.chartData.cumulative_2040_energy_investment
      )
      this.metaDatas.energyInvestment2050 = this.toGig(
        this.chartData.cumulative_2050_energy_investment
      )

      this.metaDatas.economy2030 = this.toGig(this.chartData.cumulative_2030_economy)
      this.metaDatas.economy2040 = this.toGig(this.chartData.cumulative_2040_economy)
      this.metaDatas.economy2050 = this.toGig(this.chartData.cumulative_2050_economy)

      this.$store.dispatch('loading/end_loading')
    },

    computeEnergyMixChartValues () {
      if (this.chartData.energy_mix_data) {
        let chartYear = this.energyMixChart.year
        const yearData = this.chartData.energy_mix_data[chartYear]
        const isPercentage = this.energyMixChart.dataRepresentation === 'percentage'

        const energiesLabel = []
        const energiesColors = []
        const energiesData = []

        Object.entries(yearData).forEach(([energySlug, values]) => {
          const energyLabel = this.energiesLabel[energySlug]
          energiesLabel.push(energyLabel)
          energiesColors.push(this.energiesColors[energySlug])

          let dataKey = ''
          if (this.energyMixChart.dataType === 'cost') {
            dataKey = 'cost'
          } else if (this.energyMixChart.dataType === 'consumption') {
            dataKey = 'consumption'
          } else if (this.energyMixChart.dataType === 'co2_emissions') {
            dataKey = 'prospective_CO2emissions'
          }

          energiesData.push(values[dataKey])
        })

        let chartUnit
        if (this.energyMixChart.dataType === 'cost') {
          chartUnit = '€'
        } else if (this.energyMixChart.dataType === 'consumption') {
          chartUnit = 'kWhEF'
        } else if (this.energyMixChart.dataType === 'co2_emissions') {
          chartUnit = 'tCO2eq'
        }

        if (isPercentage) {
          chartUnit = `% ${chartUnit}`
        }

        const chartTitle = `Répartition du mix énergétique ${chartYear} (${chartUnit})`

        this.energyMixChart.options = {
          responsive: true,
          maintainAspectRatio: false,
          hoverBorderWidth: 20,
          title: { display: true, text: chartTitle },
          legend: {
            position: 'bottom',
            labels: { usePointStyle: true, padding: 20, fontStyle: 'bold' }
          },
          tooltips: {
            callbacks: {
              label: this.energyMixformatTooltip
            }
          }
        }

        this.energyMixChart.dataCollection = {
          labels: energiesLabel,
          datasets: [
            {
              backgroundColor: energiesColors,
              data: energiesData
            }
          ]
        }
      }
    },

    computeYAxisBounds (chartsDatas) {
      let yMax = []
      let yMin = []

      chartsDatas.forEach((chartDatas) => {
        const chartDatasY = chartDatas.map(function (o) {
          return o.y
        })
        const dataMax = Math.max(...chartDatasY)
        const dataMin = Math.min(...chartDatasY)
        yMax.push(dataMax)
        yMin.push(dataMin)
      })

      // The exact maxY value
      const originalMaxY = Math.max(...yMax)
      const yAxisMax = this.getAxisMax(originalMaxY)
      const maxY = yAxisMax.max
      const yStep = yAxisMax.step

      //  The exact min YConsumptions value
      const originalMinY = Math.min(...yMin)

      const nbNegativeSteps =
        originalMinY < 0 ? Math.abs(Math.floor(originalMinY / yStep)) + 1 : 0

      return [nbNegativeSteps, maxY, yStep]
    },
    async loadApi () {
      await this.getScenarioDetails()
      this.loadFunctions()
      this.loadTags()

      const energiesResponse = await session.get('/api/parameters/energies/', {
        params: { showHeatPump: true }
      })

      /*
        ugly workaround for a bug in vue-material
        https://github.com/vuematerial/vue-material/issues/1904
    */
      await new Promise((resolve) => setTimeout(resolve, 300))

      this.$set(this, 'energiesList', energiesResponse.data)
      await this.$nextTick()
      this.energiesList.forEach((energy) => {
        this.energiesLabel[energy.slug] = energy.label
      })
    },
    async loadTags () {
      const scenarioId = this.$route.params.scenarioId
      const tagsResponse = await session.get(`/api/scenario/${scenarioId}/tags/`, {params: {'places_type': this.placesType}})
      const allTagsSelected = _.isEqual(this.selectedTags, this.tagsList)
      this.$set(this, 'tagsList', tagsResponse.data)
      await this.$nextTick()

      if (!allTagsSelected) {
        const selectedTagsIds = this.selectedTags.map(tag => tag.id)
        this.selectedTags = this.tagsList.filter(tag => selectedTagsIds.includes(tag.id))
      } else {
        this.selectedTags = this.tagsList
      }
    },
    async loadFunctions () {
      const scenarioId = this.$route.params.scenarioId
      const functionResponse = await session.get(
        `/api/scenario/${scenarioId}/functions/`, {params: {'places_type': this.placesType}}
      )
      const allFunctionsSelected = _.isEqual(this.selectedFunctions, this.functionsList)
      this.$set(this, 'functionsList', functionResponse.data)
      await this.$nextTick()

      if (!allFunctionsSelected) {
        const selectedFunctionsIds = this.selectedFunctions.map(func => func.id)
        this.selectedFunctions = this.functionsList.filter(func => selectedFunctionsIds.includes(func.id))
      } else {
        this.selectedFunctions = this.functionsList
      }
    },
    async downloadXLSXResult () {
      this.$store.dispatch('loading/begin_loading')
      const response = await session.get(this.scenarioDetails.xlsx_result, {
        responseType: 'arraybuffer'
      })
      let filename = ''
      const disposition = response.request.getResponseHeader('Content-Disposition')

      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '')
        }
      }
      FileDownload(response.data, filename, response.headers['content-type'])

      this.$store.dispatch('loading/end_loading')
    },

    energyMixformatTooltip (tooltipItem, data) {
      const dataset = data.datasets[tooltipItem.datasetIndex]
      const label = data.labels[tooltipItem.index]
      let value = dataset.data[tooltipItem.index]
      // Total value for selected year and data type
      let dataTotal = 0
      const datasetMeta = dataset._meta
      const datasetMetaData = Object.values(datasetMeta)[0].data
      datasetMetaData.forEach((chartElement) => {
        if (!chartElement.hidden) {
          dataTotal += dataset.data[chartElement._index]
        }
      })
      const percentageValue = (value / dataTotal) * 100

      const dataType = this.energyMixChart.dataType
      const isPercentage = this.energyMixChart.dataRepresentation === 'percentage'

      if (isPercentage) {
        value = percentageValue
      }

      let formattedValue = new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(value)

      let unit
      if (dataType === 'cost') {
        unit = '€'
      }

      if (dataType === 'consumption') {
        unit = 'kWhEF'
      }

      if (dataType === 'co2_emissions') {
        unit = 'tCO2eq'
      }

      if (isPercentage) {
        formattedValue = `${formattedValue} % (${unit})`
      } else {
        formattedValue = `${formattedValue} ${unit}`
      }

      return `${label} : ${formattedValue}`
    }
  },
  filters: {
    displayMWhConsumption (value) {
      const percentage = parseInt(value / 1000)
      return percentage + ' MWh'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";

.page-content {
  overflow: auto;
  height: calc(100vh - 64 * 2px);
}

.page-layout {
  display: flex;
  height: min-content;
}

.filters__panel {
  background-color: darken(project-theme("white"), 4);
  border-left: 1px solid darken(project-theme("white"), 10);
  padding: 0px 0px 20px 20px;
  width: 30%;
  position: relative;

  .md-mini {
    top: 7px;
    right: 8px;
    position: absolute;
    width: 35px;
    height: 35px;

    .md-button {
      left: -34px;
      top: -7px;
    }
  }
}

.results__panel {
  padding: 20px;
  width: 70%;
  display: flex;
  flex-direction: column;
}

.results__chart {
  position: relative;
  padding-top: 80px;
  display: flex;
  width: 100%;
}

.filters-panel-line {
  position: relative;
  padding-left: 20px;

  &::before {
    content: "";
    position: absolute;
    width: 12px;
    height: 100%;
    background: #86ad19;
    left: 0;
    top: 0;
  }

  >>> .md-card {
    margin: 0;
    box-shadow: none;
  }

  .consumption-table {
    .md-table-toolbar {
      min-height: 50px;
    }

    table tbody tr {
      border-top: 1px solid #ddd;
    }

    .consumption-col-header {
      width : 200px;

      >>> .md-table-head-container {
        margin: 0 !important;
        white-space: normal;
        overflow: visible;

        .md-table-head-label {
          padding-left: 5px;
          padding-right: 0;
          white-space: normal;
          overflow: visible;
          line-height: 1.5;
        }
      }
    }

    .date-header {
      >>> .md-table-head-container {
        .md-table-head-label {
          padding-left: 5px;
          padding-right: 0;
        }
      }
    }
  }

  >>> .md-table-cell {
    .md-table-cell-container {
      padding: 0;
    }
  }
}

.p-10 {
  padding: 20px 40px !important;
  position: relative;
}

.mt-2 {
  margin-top: 20px;
}

.filters-wrapper {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  flex-wrap: wrap;

  .md-field{
    width : 30%;
  }
}

.select-title {
  display: block;
  float: left;
  padding-top: 15px;
  padding-right: 15px;
}

.filters-title {
  font-weight: bold;
  font-size: 18px;
  color: #86ad19;
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: -20px;

  &.simple-card-title {
    padding: 1em;
  }
}

.selected-places-card {
  padding-bottom: 0;
}

.tabs-wrapper {
  border: 1px solid #ccc;
  padding-bottom: 20px;

  .graphs-tabs >>> .md-tabs-navigation {
    background-color: #eee !important;
    border-bottom: 1px solid #ccc !important;
    justify-content: space-between;
  }
}

.energy-mix-filters {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  >>> .md-field {
    margin: 15px;
    width: 25%;
  }
}

.function-list-table {
  position: relative;
  z-index: 2;
}

.filters-table{
  .md-table-content{
    tr{
      .md-table-cell:last-child{
        text-align: center;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/ScenarioResults.vue